import React from 'react';
import logo from "../img/logo.png";
import { Link } from "react-router-dom";

const NavbarMenu = () => {
    return (
        <div className="text-start">
            <Link to="/" className="hk-navbar-brand">
                <img style={{ maxWidth: "150px" }} src={logo} alt="Hugo Knives" />
            </Link>
        </div>
    );
};

export default NavbarMenu;
